import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { cerrarVideo } from "../js/actions/index";
import "./modalvideo.scss";

const mapStateToProps = state => {
	return { videoState: state.video };
};
function mapDispatchToProps(dispatch) {
	return {
		cerrar: () => dispatch(cerrarVideo())
	};
}
const ConnectedVideo = (props) => {
	console.log(props);
	return <div id="popupGel" className={(props.videoState.video === props.id && props.videoState.visible)?"show":"hide"} onClick={() => {props.cerrar();}}>
		<div className="ventana">
			<video  width="90%" controls>
				<source src={"content/teoria/"+props.video+".mp4"} type="video/mp4"/>
				<source src={"content/teoria/"+props.video+".WebM"} type="video/webm"/>
			</video>
		</div>
	</div>;
};
ConnectedVideo.propTypes = {
	videoState:PropTypes.object,
	cerrar:PropTypes.func,
	video:PropTypes.string,
	id:PropTypes.string
};

export default connect(mapStateToProps,mapDispatchToProps)(ConnectedVideo);